var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoiDisplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20C7 17.7145 7.8761 16.1559 9.15039 15.2002C10.3762 14.2809 11.8605 14 13 14C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16C12.1396 16 11.1238 16.2192 10.3496 16.7998C9.62397 17.3441 9 18.2857 9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12 12.7348 11.8946 12.4805 11.707 12.293C11.5195 12.1054 11.2652 12 11 12H6C5.73478 12 5.48051 12.1054 5.29297 12.293C5.10543 12.4805 5 12.7348 5 13V18L5.00488 18.0986C5.02757 18.3276 5.12883 18.5429 5.29297 18.707C5.48051 18.8946 5.73478 19 6 19H11C11.2652 19 11.5195 18.8946 11.707 18.707C11.8946 18.5195 12 18.2652 12 18V13ZM14 18C14 18.7957 13.6837 19.5585 13.1211 20.1211C12.5585 20.6837 11.7957 21 11 21H6C5.20435 21 4.44152 20.6837 3.87891 20.1211C3.3163 19.5585 3 18.7956 3 18V13C3 12.2044 3.3163 11.4415 3.87891 10.8789C4.44152 10.3163 5.20435 10 6 10H11C11.7957 10 12.5585 10.3163 13.1211 10.8789C13.6837 11.4415 14 12.2043 14 13V18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7V5C3 4.46957 3.21087 3.96101 3.58594 3.58594C3.96101 3.21087 4.46957 3 5 3H7C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5H5V7C5 7.55228 4.55228 8 4 8C3.44772 8 3 7.55228 3 7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C13.5523 3 14 3.44772 14 4C14 4.55228 13.5523 5 13 5H11C10.4477 5 10 4.55228 10 4C10 3.44772 10.4477 3 11 3H13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7V5H17C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H19C19.5304 3 20.039 3.21086 20.4141 3.58594C20.7891 3.96101 21 4.46957 21 5V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13V11C19 10.4477 19.4477 10 20 10C20.5523 10 21 10.4477 21 11V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19V17C19 16.4477 19.4477 16 20 16C20.5523 16 21 16.4477 21 17V19C21 19.5304 20.7891 20.039 20.4141 20.4141C20.039 20.7891 19.5304 21 19 21H17C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19H19Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoiDisplay);
export default __webpack_public_path__ + "static/media/roi-display.44d754e31baf6d90ef27f49be2069d3f.svg";
export { ForwardRef as ReactComponent };